import Image from 'next/image';
import { SVGProps } from 'react';

export const SVGPremium = ({ width = '121px', height = '157px' }: SVGProps<SVGElement>) => {
  return <Image src="/images/envelop.png" alt="Premium" width={width} height={height} />;
};
